import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { adminApiHeader, finalRouteApi } from '../../components/CommonApis/CommonApiUrl';
import { Link } from 'react-router-dom';
import AdminBackNavigation from '../../components/CommonComponents/AdminBackNavigation';

export default function FieldSetsList(){
  const [sets, setSets] = useState([]);
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => { let m=true; (async()=>{
    try{
      const feat = await axios.get(`${finalRouteApi}/admin/features/custom-fields`, { headers: adminApiHeader });
      if(!m) return;
      if(!feat.data?.enabled){ setEnabled(false); setLoading(false); return; }
      setEnabled(true);
      const res = await axios.get(`${finalRouteApi}/custom-field-sets`, { headers: adminApiHeader });
      if(!m) return; setSets(res.data?.sets||[]);
    }catch(e){ setError(e?.response?.data?.message||e.message); }finally{ setLoading(false); }
  })(); return ()=>{m=false}; },[]);

  if(loading) return <div>Loading…</div>;
  if(!enabled) return <div>Custom Fields addon is disabled.</div>;

  return (
    <div>
      <AdminBackNavigation path="/custom-fields" text="Back to Custom Fields" />
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <h2>Field Sets</h2>
        <Link to="/custom-fields/sets/create" className="btn btn-primary">Create Set</Link>
      </div>
      {error && <div style={{color:'red'}}>{error}</div>}
      <table className="table"><thead><tr><th>Name</th><th>Active</th><th>Items</th><th>Actions</th></tr></thead>
        <tbody>
          {(sets||[]).map(s=> (
            <tr key={s.id}>
              <td>{s.name}</td>
              <td>{s.active? 'Yes':'No'}</td>
              <td>{Array.isArray(s.items)? s.items.length: 0}</td>
              <td><Link to={`/custom-fields/sets/edit/${s.id}`}>Edit</Link></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
